<template>
  <div class="flex flex-col  overflow-hidden">

    <div v-if="documentInfoList.length==0 && !selectedDocument">
      <DocumentSearch @update-document-number="updateDocumentNumber" :loading="loading"></DocumentSearch>
    </div>
    <div v-else-if="documentInfoList.length >= 1">
      <DocumentInfoList @select-document-number="selectDocumentNumber" :documentInfoList="documentInfoList"></DocumentInfoList>
    </div>


  </div>
</template>
<script setup>


import DocumentSearch from '@/partials/DocumentSearch.vue'
import DocumentInfo from '@/partials/DocumentInfo.vue'
import DocumentInfoList from '@/partials/DocumentInfoList.vue'
import {defineEmits, onMounted, reactive, ref} from "vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import axios from 'axios';


const emits = defineEmits(['select-document-number']);

const props = defineProps({
  documentNumberProp: {
    type: String,
  },loading: {
    type: Boolean,
    required: false,
    default: false
  },


})

const documentNumber = ref(null)
const loading = ref(false)
const documentInfoList = ref([])
const selectedDocument = ref(null)



const getDocumentInfo = async () => {
  loading.value = true;
  await axios
      .post(route('public.api.getDocumentInfo'), { documentNumber: documentNumber.value })
      .then(response => {
        documentInfoList.value = response.data.data;
        if (documentInfoList.value.length == 1) {
          selectedDocument.value = documentInfoList.value[0];
        } else {
          selectedDocument.value = null;
        }

      })
  loading.value = false;
}



const updateDocumentNumber = (documentNumberText) => {
  documentNumber.value = documentNumberText
  getDocumentInfo(documentNumber)
}

const selectDocumentNumber = (index) => {
  emits('select-document-number', documentInfoList.value[index]);
}


onMounted(() => {
  documentNumber.value = usePage().props.value.documentNumberProp
  selectedDocument.value=null;
  if (documentNumber.value) {
    getDocumentInfo(documentNumber)
  }



});

</script>

